import { render, staticRenderFns } from "./LateralFichaAreaMini.vue?vue&type=template&id=3752c29a&scoped=true&"
import script from "./LateralFichaAreaMini.vue?vue&type=script&lang=js&"
export * from "./LateralFichaAreaMini.vue?vue&type=script&lang=js&"
import style0 from "./LateralFichaAreaMini.vue?vue&type=style&index=0&id=3752c29a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3752c29a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VListTile,
  VListTileAction,
  VTooltip,
})
